import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AssessmentService } from '../../services/assessment-service/assessment.service';

export const assessmentStateGuard: CanActivateFn = () => {
  const assessmentService: AssessmentService = inject(AssessmentService);
  const router: Router = inject(Router);
  if (assessmentService.getCurrentAssessmentWrapperId()) {
    return true;
  } else {
    return router.navigateByUrl('/initial-information');
  }
};
